import { render, staticRenderFns } from "./recordProductsReceived.vue?vue&type=template&id=4b935599&scoped=true"
import script from "./recordProductsReceived.vue?vue&type=script&lang=js"
export * from "./recordProductsReceived.vue?vue&type=script&lang=js"
import style0 from "./recordProductsReceived.vue?vue&type=style&index=0&id=4b935599&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b935599",
  null
  
)

export default component.exports